import { ModelApiService } from './BaseApiService'

export default class DisputesApiService extends ModelApiService {
  constructor() {
    super('disputes')
  }

  /**
   *
   * @param {DisputeListQuery} disputeListParams
   * @return {Promise<*>}
   */
  async getBookingDisputeList(disputeListParams) {
    return await this.get(``, disputeListParams)
  }

  /**
   *
   * @param {DisputeListQuery} disputeListParams
   * @return {Promise<*>}
   */
  async getBookingDisputeListV2(disputeListParams) {
    return await this.get(`v2`, disputeListParams)
  }

  /**
   * @param {DisputeListQuery} disputeListParams
   * @return {Promise<*>}
   */
  async getDisputeFollowUpTasks(disputeListParams) {
    return await this.get(`tasks`, disputeListParams)
  }

  /**
   * @param {number} bookingId
   */
  async getDisputeByBookingId(bookingId) {
    return await this.get(`${bookingId}`)
  }

  async getAllowedViewableAdminIds() {
    return await this.get(`viewable-admins`)
  }

  async submitTimesheets(payload) {
    return await this.post('resolve', payload)
  }

  async getInvoiceCenterGroupedSummary({ invoiceCenterId, dateUntil }) {
    return await this.get(
      `grouped-summary?invoiceCenterIds=${invoiceCenterId}&dateUntil=${dateUntil}`
    )
  }

  async bulkResolveInvoiceCenter({
    invoiceCenterId,
    operation,
    summary,
    dateUntil,
  }) {
    return this.post(
      `resolve/${invoiceCenterId}?operationType=${operation}&dateUntil=${dateUntil}`,
      summary
    )
  }
}
